import { render, staticRenderFns } from "./ButtonUI.vue?vue&type=template&id=ce566ad6&scoped=true&"
import script from "./ButtonUI.vue?vue&type=script&lang=js&"
export * from "./ButtonUI.vue?vue&type=script&lang=js&"
import style0 from "./ButtonUI.vue?vue&type=style&index=0&id=ce566ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce566ad6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
